import { render, staticRenderFns } from "./RequestOtp.vue?vue&type=template&id=6041a716&"
import script from "./RequestOtp.vue?vue&type=script&lang=js&"
export * from "./RequestOtp.vue?vue&type=script&lang=js&"
import style0 from "./RequestOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports